<template>
  <div v-loading="loading" class="batch-track-wrapper">
    <div class="sidebar-wrapper">
      <div>
        <h2>渠道列表：</h2>
        <div>共{{ formChannelsInfo.total }}个渠道；已保存：{{ formChannelsInfo.is_save_length }}个；<span style="color:red">未保存：{{ formChannelsInfo.is_no_save_length }}个</span></div>
      </div>
      <el-button
        icon="el-icon-plus"
        style="margin: 10px 0;"
        size="mini"
        type="primary"
        @click="addTab"
      >
        新增渠道
      </el-button>
      <div ref="tagScrollbarRef" class="tag-scrollbar-wrapper">
        <div v-for="(tag,index) in Object.keys(ruleForm.channels)" :key="tag">
          <el-badge :hidden="(tag !== current_tab)" is-dot>
            <el-tag
              style="margin-bottom:15px"
              class="custom-cursor-pointer tag-item"
              :class="{active: tag === current_tab}"
              :closable="Object.keys(ruleForm.channels).length > 1"
              :type="getTagType(ruleForm.channels[tag])"
              @click="onClickTab(ruleForm.channels[tag])"
              @close="onRemoveTab(ruleForm.channels[tag].tab_uuid)"
            >
              <el-tooltip v-if="ruleForm.channels[tag].tab_is_save" effect="dark" placement="left">
                <div slot="content" v-html="ruleForm.channels[tag].tab_title" />
                <span>渠道 {{ index + 1 }} </span>
              </el-tooltip>
              <span v-else>{{ ruleForm.channels[tag].tab_title }} {{ index + 1 }}</span>
            </el-tag>
          </el-badge>
          <el-button v-if="ruleForm.channels[tag].tab_is_save" style="margin-left: 5px" type="text" size="mini" @click="onCopyChannel(ruleForm.channels[tag].tab_uuid)">复制</el-button>
        </div>
      </div>
    </div>
    <el-row class="content-wrapper">
      <div class="template-action">
        <el-button type="primary" size="mini" @click="onSaveTemplate">保存模板</el-button>
        <el-button type="success" size="mini" @click="onReadTemplate">读取模板</el-button>
      </div>
      <el-col>
        <el-form
          ref="ruleForm"
          :model="ruleForm"
          :rules="rules"
          size="mini"
          label-width="150px"
          class="track_form"
        >
          <div style="margin-bottom: 40px;">
            <div>
              <h2>渠道参数</h2>
              <!-- 渠道名称 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.name'"
                :rules="{
                  required: true,
                  message: '渠道名称不能为空',
                  trigger: ['blur', 'change'],
                }"
                label="渠道名称"
                :prop="'channels.' + current_tab + '.name'"
              >
                <el-input
                  v-model="ruleForm.channels[current_tab].name"
                  clearable
                  size="mini"
                  placeholder="渠道名称"
                />
                <div>
                  示例：zqd-[1-100], 批量创建zqd-1 ~ zqd-100,
                  渠道标识和渠道名称区间范围必须相同
                </div>
              </el-form-item>
              <!-- 渠道标识 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.alias'"
                :rules="{
                  required: true,
                  message: '渠道标识不能为空',
                  trigger: ['blur', 'change'],
                }"
                label="渠道标识"
                :prop="'channels.' + current_tab + '.alias'"
              >
                <el-input
                  v-model="ruleForm.channels[current_tab].alias"
                  clearable
                  size="mini"
                  placeholder="渠道标识"
                />
                <div>
                  示例：qd-[1-100], 批量创建qd-1 ~ qd-100,
                  渠道标识和渠道名称区间范围必须相同
                </div>
              </el-form-item>
              <!-- 平台标识 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.plf_type'"
                :rules="[
                  {
                    required: true,
                    message: '请选择平台标识',
                    trigger: ['blur', 'change'],
                  },
                ]"
                label="平台标识"
                :prop="'channels.' + current_tab + '.plf_type'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].plf_type"
                  style="width: 100%;"
                  size="mini"
                  placeholder="请选择平台标识"
                >
                  <el-option
                    v-for="plf_type_item in plf_type_options.response"
                    :key="plf_type_item.id"
                    :label="plf_type_item.label"
                    :value="plf_type_item.id"
                  />
                </el-select>
              </el-form-item>
              <!-- 广告商 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.config.advertiser'"
                :rules="[
                  {
                    required: true,
                    message: '请选择广告商',
                    trigger: ['blur', 'change'],
                  },
                ]"
                label="广告商"
                :prop="'channels.' + current_tab + '.config.advertiser'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].config.advertiser"
                  style="width: 100%;"
                  size="mini"
                  placeholder="请选择广告商"
                >
                  <el-option
                    v-for="advertiser_item in advertiser_options.response"
                    :key="advertiser_item.value"
                    :label="advertiser_item.label"
                    :value="advertiser_item.value"
                  />
                </el-select>
              </el-form-item>
              <!-- 分类 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.type1'"
                :rules="[
                  {
                    required: true,
                    message: '请选择分类',
                    trigger: ['blur', 'change'],
                  },
                ]"
                label="分类"
                :prop="'channels.' + current_tab + '.type1'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].type1"
                  style="width: 100%;"
                  size="mini"
                  placeholder="请选择分类"
                  @change="onType1Change"
                >
                  <el-option
                    v-for="advertiser_item in advertiser.response"
                    :key="advertiser_item.id"
                    :label="advertiser_item.name"
                    :value="advertiser_item.id"
                  />
                </el-select>
              </el-form-item>
              <!-- 子分类 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.type2'"
                :rules="[
                  {
                    required: true,
                    message: '请选择子分类',
                    trigger: ['blur', 'change'],
                  },
                ]"
                label="子分类"
                :prop="'channels.' + current_tab + '.type2'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].type2"
                  style="width: 100%;"
                  filterable
                  size="mini"
                  placeholder="请选择子分类"
                >
                  <el-option
                    v-for="type2_item in type2_options[current_tab].response"
                    :key="type2_item.id"
                    :label="type2_item.name"
                    :value="type2_item.id"
                  />
                </el-select>
              </el-form-item>
              <!-- 出价方式 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.config.bid_mode'"
                :rules="[
                  {
                    required: true,
                    message: '请选择出价方式',
                    trigger: ['blur', 'change'],
                  },
                ]"
                label="出价方式"
                :prop="'channels.' + current_tab + '.config.bid_mode'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].config.bid_mode"
                  style="width: 100%;"
                  size="mini"
                  placeholder="请选择出价方式"
                  @change="onBidModeChange"
                >
                  <el-option
                    v-for="bid_mode_item in api_bid_mode_options.response"
                    :key="bid_mode_item.value"
                    :label="bid_mode_item.label"
                    :value="bid_mode_item.value"
                  />
                </el-select>
              </el-form-item>
              <!-- 游戏 -->
              <el-form-item
                v-if="ruleForm.channels[current_tab]"
                :ref="'channels.' + current_tab + '.game_id'"
                :rules="[
                  {
                    required: true,
                    message: '请选择游戏',
                    trigger: ['blur', 'change'],
                  },
                ]"
                label="游戏"
                :prop="'channels.' + current_tab + '.game_id'"
              >
                <select-tree
                  ref="select-tree"
                  style="width: 100%;"
                  :value="ruleForm.channels[current_tab]?.game_id"
                  v-bind="filter_obj.game_ids.props"
                  v-on="filter_obj.game_ids.on"
                />
              </el-form-item>
              <!-- appid -->
              <el-form-item
                :ref="'channels.' + current_tab + '.config.app_id'"
                :rules="[
                  {
                    required: true,
                    message: 'AppId不能为空',
                    trigger: ['blur', 'change'],
                  },
                ]"
                label="AppId"
                :prop="'channels.' + current_tab + '.config.app_id'"
              >
                <el-input
                  v-model="ruleForm.channels[current_tab].config.app_id"
                  clearable
                  size="mini"
                  placeholder="AppId"
                />
              </el-form-item>
              <!-- 广告商ID -->
              <el-form-item
                :ref="'channels.' + current_tab + '.config.ad_account'"
                :rules="[
                  {
                    required: true,
                    message: '广告商ID不能为空',
                    trigger: ['blur', 'change'],
                  },
                  {
                    type: 'number',
                    message: '必须为数字值',
                    trigger: ['blur', 'change'],
                  },
                ]"
                label="广告商ID"
                :prop="'channels.' + current_tab + '.config.ad_account'"
              >
                <el-input
                  v-model.number="ruleForm.channels[current_tab].config.ad_account"
                  clearable
                  size="mini"
                  placeholder="广告商ID"
                />
              </el-form-item>
              <!-- 费用分摊 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.config.cost_type'"
                label="费用分摊"
                :prop="'channels.' + current_tab + '.config.cost_type'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].config.cost_type"
                  style="width: 100%;"
                  size="mini"
                  filterable
                  placeholder="请选择费用分摊"
                >
                  <el-option
                    v-for="cost_type_item in cost_type_options.response"
                    :key="cost_type_item.id"
                    :label="cost_type_item.label"
                    :value="cost_type_item.id"
                  />
                </el-select>
              </el-form-item>
              <!-- 平台 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.config.platform'"
                label="平台"
                :prop="'channels.' + current_tab + '.config.platform'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].config.platform"
                  style="width: 100%;"
                  size="mini"
                  filterable
                  placeholder="请选择平台"
                >
                  <el-option
                    v-for="platform_item in platform_options.response"
                    :key="platform_item.id"
                    :label="platform_item.label"
                    :value="platform_item.id"
                  />
                </el-select>
              </el-form-item>
              <!-- 使用主渠道上报类型 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.config.parent_callback_type'"
                label="使用主渠道上报类型"
                :prop="'channels.' + current_tab + '.config.parent_callback_type'"
              >
                <el-checkbox v-model="ruleForm.channels[current_tab].config.parent_callback_type" :true-label="1" :false-label="0" />
              </el-form-item>
              <!-- 上报类型 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.config.callback_type'"
                label="上报类型"
                :prop="'channels.' + current_tab + '.config.callback_type'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].config.callback_type"
                  style="width: 100%;"
                  multiple
                  clearable
                  filterable
                  size="mini"
                  placeholder="请选择上报类型"
                >
                  <el-option
                    v-for="callback_type_item in callback_type_options.response"
                    :key="callback_type_item.id"
                    :label="callback_type_item.label"
                    :value="callback_type_item.id"
                  />
                </el-select>
                <div>头条 SDK 上报无法限制激活，必会 100% 上报</div>
              </el-form-item>
              <!-- 上报方法 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.config.callback_method'"
                label="上报方法"
                :prop="'channels.' + current_tab + '.config.callback_method'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].config.callback_method"
                  style="width: 100%;"
                  filterable
                  size="mini"
                  placeholder="请选择上报方法"
                >
                  <el-option
                    v-for="callback_method_item in callback_method_options.response"
                    :key="callback_method_item.id"
                    :label="callback_method_item.label"
                    :value="callback_method_item.id"
                  />
                </el-select>
              </el-form-item>
              <!-- 素材类别 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.material_type'"
                label="素材类别"
                :prop="'channels.' + current_tab + '.material_type'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].material_type"
                  style="width: 100%;"
                  filterable
                  size="mini"
                  placeholder="请选择素材类别"
                  @change="onMaterialTypeChange"
                >
                  <el-option
                    v-for="material_type_item in material_type_options.response"
                    :key="material_type_item.id"
                    :label="material_type_item.label"
                    :value="material_type_item.id"
                  />
                </el-select>
              </el-form-item>
              <!-- 投放素材 -->
              <el-form-item
                :ref="'channels.' + current_tab + '.material_id'"
                label="投放素材"
                :prop="'channels.' + current_tab + '.material_id'"
              >
                <el-select
                  v-model="ruleForm.channels[current_tab].material_id"
                  :disabled="ruleForm.channels[current_tab].material_type !== map_material_type.landing_page"
                  style="width: 100%;"
                  filterable
                  size="mini"
                  placeholder="请选择投放素材"
                >
                  <el-option
                    v-for="material_id_item in material_id_options[current_tab].response"
                    :key="material_id_item.id"
                    :label="material_id_item.name"
                    :value="material_id_item.id"
                  />
                </el-select>
              </el-form-item>
              <!-- 转化参数 -->
              <div v-for="(convert, index) in ruleForm.channels[current_tab].converts" :key="index">
                <h3 v-show="ruleForm.channels[current_tab].converts.length > 1" style="margin-left: 100px;color: #1890ff;">组合{{ index+1 }}</h3>
                <!-- 优化目标类型 -->
                <el-form-item
                  :ref="'channels.' + current_tab + `.converts.${index}.optimization_goal`"
                  :prop="'channels.' + current_tab + `.converts.${index}.optimization_goal`"
                  label="优化目标类型"
                  :rules="[{
                    required: true,
                    message: '请选择优化目标',
                    trigger: ['blur', 'change'],
                  }]"
                >
                  <el-select
                    v-model="convert.optimization_goal"
                    filterable
                    clearable
                    size="mini"
                    placeholder="请选择优化目标类型"
                  >
                    <el-option
                      v-for="item in $store.getters.gdtEnum.api_optimization_goal"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
                <!-- 深度优化行为目标 -->
                <el-form-item
                  :ref="'channels.' + current_tab + `.converts.${index}.deep_behavior_optimization_goal`"
                  label="深度优化行为目标"
                  :prop="'channels.' + current_tab + `.converts.${index}.deep_behavior_optimization_goal`"
                >
                  <el-select
                    v-model="convert.deep_behavior_optimization_goal"
                    size="mini"
                    clearable
                    :disabled="!!convert.deep_worth_optimization_goal"
                    placeholder="请选择深度优化行为目标"
                    @change="(val) => changeDeep(val ,index)"
                  >
                    <el-option
                      v-for="item in $store.getters.gdtEnum.api_optimization_goal"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                      :disabled="ruleForm.channels[current_tab].converts.length === 2 && ruleForm.channels[current_tab].converts[index === 0 ? 1 : 0].deep_behavior_optimization_goal === item.value && ruleForm.channels[current_tab].config.bid_mode === 'mixed_variable_roi'"
                    />
                  </el-select>
                </el-form-item>
                <!-- 深度优化 ROI 目标 -->
                <el-form-item
                  :ref="'channels.' + current_tab + `.converts.${index}.deep_worth_optimization_goal`"
                  label="深度优化 ROI 目标"
                  :prop="'channels.' + current_tab + `.converts.${index}.deep_worth_optimization_goal`"
                >
                  <el-select
                    v-model="convert.deep_worth_optimization_goal"
                    size="mini"
                    clearable
                    :disabled="!!convert.deep_behavior_optimization_goal"
                    placeholder="请选择深度优化 ROI 目标"
                    @change="(val) => changeROI(val,index)"
                  >
                    <el-option
                      v-for="item in $store.getters.gdtEnum.api_deep_worth_optimization_goal"
                      :key="item.value"
                      :label="item.label"
                      :disabled="ruleForm.channels[current_tab].converts.length === 2 && ruleForm.channels[current_tab].converts[index === 0 ? 1 : 0].deep_worth_optimization_goal === item.value && ruleForm.channels[current_tab].config.bid_mode === 'mixed_variable_roi'"
                      :value="item.value"
                    />
                  </el-select>
                </el-form-item>
              </div>
              <el-divider class="w-full text-center">
                <el-button type="text" @click="ruleForm.channels[current_tab].collapse_callback = !ruleForm.channels[current_tab].collapse_callback">
                  <span>上报设置</span>
                  <span class="ml-10">{{ ruleForm.channels[current_tab].collapse_callback ? '展开' : '隐藏' }}</span>
                </el-button>
              </el-divider>
              <div v-show="!ruleForm.channels[current_tab].collapse_callback">
                <!-- 上报起始金额 -->
                <el-form-item
                  :ref="'channels.' + current_tab + '.config.callback_min_pay'"
                  label="上报起始金额"
                  :prop="'channels.' + current_tab + '.config.callback_min_pay'"
                >
                  <el-input
                    v-model="ruleForm.channels[current_tab].config.callback_min_pay"
                    clearable
                    size="mini"
                    type="number"
                    placeholder="请输入上报起始金额"
                  />
                  <div>低于该值的订单将不会被上报</div>
                </el-form-item>
                <!-- 上报最大金额 -->
                <el-form-item
                  :ref="'channels.' + current_tab + '.config.callback_max_pay'"
                  label="上报最大金额"
                  :prop="'channels.' + current_tab + '.config.callback_max_pay'"
                >
                  <el-input
                    v-model="ruleForm.channels[current_tab].config.callback_max_pay"
                    clearable
                    size="mini"
                    type="number"
                    placeholder="请输入上报最大金额"
                  />
                  <div>高于该值的订单将会按该值上报金额</div>
                </el-form-item>
                <!-- 上报金额百分比 -->
                <el-form-item
                  :ref="'channels.' + current_tab + '.config.callback_pay_percent'"
                  label="上报金额百分比"
                  :prop="'channels.' + current_tab + '.config.callback_pay_percent'"
                >
                  <el-input
                    v-model="ruleForm.channels[current_tab].config.callback_pay_percent"
                    clearable
                    size="mini"
                    type="number"
                    placeholder="请输入上报金额百分比"
                  />
                  <div>上报付费的金额将乘以该比例向上取整，即比例设置 50 时，支付 6 元的订单，会上报为 3 元订单</div>
                </el-form-item>
                <!-- 仅上报注册当日首充付费 -->
                <el-form-item
                  :ref="'channels.' + current_tab + '.config.callback_first_pay'"
                  label="仅上报注册当日首充付费"
                  :prop="'channels.' + current_tab + '.config.callback_first_pay'"
                >
                  <el-select
                    v-model="ruleForm.channels[current_tab].config.callback_first_pay"
                    style="width: 100%;"
                    filterable
                    size="mini"
                    placeholder="请选择仅上报注册当日首充付费"
                  >
                    <el-option
                      v-for="callback_first_pay_item in callback_first_pay_options.response"
                      :key="callback_first_pay_item.id"
                      :label="callback_first_pay_item.label"
                      :value="callback_first_pay_item.id"
                    />
                  </el-select>
                  <div style="color:red">注意是注册当日的首充才会上报，该选项为「开」时「上报付费事件时效」配置将失效</div>
                </el-form-item>
                <!-- 上报付费事件时效 -->
                <el-form-item
                  :ref="'channels.' + current_tab + '.config.callback_pay_date'"
                  label="上报付费事件时效"
                  :prop="'channels.' + current_tab + '.config.callback_pay_date'"
                >
                  <el-select
                    v-model="ruleForm.channels[current_tab].config.callback_pay_date"
                    filterable
                    size="mini"
                    placeholder="请选择上报付费事件时效"
                  >
                    <el-option
                      v-for="callback_pay_date_item in callback_pay_date_options.response"
                      :key="callback_pay_date_item.id"
                      :label="callback_pay_date_item.label"
                      :value="callback_pay_date_item.id"
                    />
                  </el-select>
                  <div style="color:red">当「仅上报注册当日首充付费」为「开」时该配置将失效</div>
                </el-form-item>
                <!-- 注册 N 天以内上报充值比例 X%，之后 100% 上报 N 为： -->
                <el-row>
                  <el-col :span="12">
                    <el-form-item
                      :ref="'channels.' + current_tab + '.config.callback_type_pay_rate_n_day'"
                      label="注册N天内充值上报几率X%，之后100%上报，N 为"
                      :prop="'channels.' + current_tab + '.config.callback_type_pay_rate_n_day'"
                    >
                      <el-input
                        v-model="ruleForm.channels[current_tab].config.callback_type_pay_rate_n_day"
                        clearable
                        size="mini"
                        type="number"
                        placeholder="请输入"
                      />
                      <div style="color:red">当「仅上报注册当日首充付费」为「开」时该配置将失效，设置天数，不填写或填 0 不生效</div>
                    </el-form-item>
                  </el-col>
                  <el-col :span="12">
                    <el-form-item
                      :ref="'channels.' + current_tab + '.config.callback_type_pay_rate_n_rate'"
                      label-width="60px"
                      class="w-full"
                      label="X 为"
                      :prop="'channels.' + current_tab + '.config.callback_type_pay_rate_n_rate'"
                    >
                      <el-input
                        v-model="ruleForm.channels[current_tab].config.callback_type_pay_rate_n_rate"
                        clearable
                        size="mini"
                        type="number"
                        class="w-full"
                        placeholder="请输入"
                      />
                      <div>设置比例，不填写或填 0 不生效</div>
                    </el-form-item>
                  </el-col>
                </el-row>
                <!-- 充值上报几率（%） -->
                <el-form-item
                  :ref="'channels.' + current_tab + '.config.pay_callback_rate'"
                  label="充值上报几率（%）"
                  :prop="'channels.' + current_tab + '.config.pay_callback_rate'"
                >
                  <el-input
                    v-model="ruleForm.channels[current_tab].config.pay_callback_rate"
                    clearable
                    size="mini"
                    type="number"
                    placeholder="请输入上充值上报几率（%）"
                  />
                  <div style="color:red">当「仅上报注册当日首充付费」为「开」时该配置将失效，不填写或填 0 相当于 100% 上报。 如无需上报，请在「上报类型」处取消「充值」勾选</div>
                </el-form-item>
                <!-- 激活上报几率（%） -->
                <el-form-item
                  :ref="'channels.' + current_tab + '.config.callback_type_active_rate'"
                  label="激活上报几率（%）"
                  :prop="'channels.' + current_tab + '.config.callback_type_active_rate'"
                >
                  <el-input
                    v-model="ruleForm.channels[current_tab].config.callback_type_active_rate"
                    clearable
                    size="mini"
                    type="number"
                    placeholder="请输入激活上报几率（%）"
                  />
                  <div>不填写或填 0 相当于 100% 上报。 如无需上报，请在「上报类型」处取消「激活」勾选</div>
                </el-form-item>
                <!-- 注册上报几率（%） -->
                <el-form-item
                  :ref="'channels.' + current_tab + '.config.callback_type_register_rate'"
                  label="注册上报几率（%）"
                  :prop="'channels.' + current_tab + '.config.callback_type_register_rate'"
                >
                  <el-input
                    v-model="ruleForm.channels[current_tab].config.callback_type_register_rate"
                    clearable
                    size="mini"
                    type="number"
                    placeholder="请输入注册上报几率（%）"
                  />
                  <div>不填写或填 0 相当于 100% 上报。 如无需上报，请在「上报类型」处取消「注册」勾选</div>
                </el-form-item>
              </div>
              <!-- 操作保存和重置 -->
              <div class="dialog-footer">
                <el-button
                  icon="el-icon-arrow-left"
                  type="success"
                  size="mini"
                  @click="onChannelSave(ruleForm.channels[current_tab])"
                >保存</el-button>
                <el-button
                  size="mini"
                  icon="el-icon-refresh-left"
                  @click="onChannelReset(ruleForm.channels[current_tab])"
                >恢复默认</el-button>
              </div>
              <div>
                <el-divider />
                <!-- 分包参数 -->
                <el-row>
                  <el-col>
                    <el-form-item
                      :rules="[{ required: true, message: '必选', trigger: ['change'] }]"
                      prop="add_extend_package"
                      label-width="0px"
                    >
                      <el-checkbox
                        v-model="ruleForm.add_extend_package"
                      >自动添加现有游戏渠道包</el-checkbox>
                    </el-form-item>
                  </el-col>
                </el-row>
                <el-row>
                  <el-col>
                    <div>
                      <el-select
                        v-model="table_advertiser.checked"
                        v-loading="table_advertiser.loading"
                        placeholder="请选择广告投放账号"
                        size="mini"
                        filterable
                        @change="changeAdvertiser"
                      >
                        <el-option
                          v-for="table_advertiser_item in table_advertiser.response"
                          :key="table_advertiser_item.id"
                          :label="table_advertiser_item.note"
                          :value="table_advertiser_item.id"
                        >
                          {{ table_advertiser_item.label }}
                          <span style="color:darkgray">{{ table_advertiser_item.note }}</span>
                        </el-option>
                      </el-select>
                      <div style="margin:15px 0" :class="[multiple_selection.length ? 'visible' : 'invisible']">
                        已选：{{ multiple_selection.length }}/{{ app.response.list.length }}
                      </div>
                      <el-table
                        ref="multipleTable"
                        :data="app.response.list"
                        border
                        stripe
                        size="mini"
                        @selection-change="handleSelectionChange"
                      >
                        <el-table-column type="selection" width="55" />
                        <el-table-column v-for="column in create_track_table_key" :key="column.value" :align="column.align" :prop="column.value" :label="column.name" />
                      </el-table>
                    </div>
                  </el-col>
                </el-row>
              </div>
            </div>
          </div>
        </el-form>
      </el-col>
      <el-col class="dialog-footer actions-wrap">
        <div>
          <el-button icon="el-icon-close" size="mini" @click="closeAddDialog">取 消</el-button>
          <el-button
            :loading="submit_loading"
            icon="el-icon-position"
            size="mini"
            type="primary"
            @click="configAddDialog"
          >确 定</el-button>
        </div>
      </el-col>
    </el-row>
    <el-drawer
      :visible.sync="template_config.is_show"
      :append-to-body="true"
      :modal-append-to-body="true"
    >
      <span slot="title" class="font-16">{{ template_config.title }}</span>
      <template-list v-if="template_config.is_show" class="p-20" :init-config="template_config.init_config" @confirm="applicationTemplate" />
    </el-drawer>
  </div>
</template>
<script>
import { getChannelInterfaceAdvertiserApi } from '@/api/channel-interface/advertiser';

import ConvertResource from '@/api/tool/convert/gdt';
const convertResource = new ConvertResource();

import AdvertisingResource from '@/api/advertising';
const advertisingResource = new AdvertisingResource();

import AdvResource from '@/api/adv';
const advResource = new AdvResource();

import ConfigResource from '@/api/config';
const configResource = new ConfigResource();

import { isNullOrUnDef, isObject, isNull, isArray } from '@/utils/is';
import store from '@/store';
import { clone, randomUUID } from '@/utils';
import TemplateResource from '@/api/template';
import { CHANNEL_INTERFACE_TYPE } from '@/enums';
import { getDeliveryContentApi } from '@/api/tool/delivery-content';

const templateResource = new TemplateResource();

export default {
  components: {
    'select-tree': () => import('@/components/select-tree'),
    'template-list': () => import('./template/index.vue'),
  },
  data() {
    return {
      // 模板配置
      template_config: {
        is_show: false,
        title: '模板列表',
        template_data: '',
      },
      /** 素材类别 */
      map_material_type: {
        /** 落地页 */
        landing_page: 1,
      },
      submit_loading: false,
      create_track_table_key: require('../module/create-track-table-key.js')(this),
      table_params: {
        loading: false,
        params: {
          advertiser_id: null,
          is_list: 1,
          promoted_object_type: 'PROMOTED_OBJECT_TYPE_APP_ANDROID',
          app_ids: [],
        },
        response: {},
      },
      /** 应用分包多选数据集 */
      multiple_selection: [],
      /** 应用ID */
      app: {
        loading: false,
        params: {},
        response: { list: [], page_info: { total_number: 0 }},
      },
      current_tab: '0',
      loading: false,
      /** 费用分摊 */
      cost_type_options: {
        loading: false,
        response: [
          { id: 0, label: '默认' },
          { id: 1, label: '广告PV' },
          { id: 2, label: '下载' },
          { id: 3, label: '激活' },
          { id: 4, label: '注册' },
        ],
      },
      /** 平台 */
      platform_options: {
        loading: false,
        response: [
          { id: 1, label: 'IOS' },
          { id: 3, label: '安卓' },
        ],
      },
      /** 广告商下拉框数据 */
      advertiser_options: {
        loading: false,
        response: [],
      },
      /** 上报类型 */
      callback_type_options: {
        loading: false,
        response: [
          { id: 'active', label: '激活' },
          { id: 'register', label: '注册' },
          { id: 'register_as_active', label: '注册当激活' },
          { id: 'pay', label: '充值' },
          { id: 'key', label: '关键' },
          { id: 'purchase_roi', label: '付费roi' },
          { id: 'create_role', label: '创角' },
        ],
      },
      /** 仅上报注册当日首充付费 */
      callback_first_pay_options: {
        loading: false,
        response: [
          { id: 1, label: '开' },
          { id: 0, label: '关' },
        ],
      },
      /** 上报方法 */
      callback_method_options: {
        loading: false,
        response: [
          { id: 'api', label: 'API' },
          { id: 'sdk', label: 'SDK' },
        ],
      },
      /** 平台标识数据集 */
      plf_type_options: {
        loading: false,
        response: [
          { id: 1, label: '思璞2.0SDK' },
          { id: 2, label: '云履SDK' },
          { id: 3, label: '宾麒SDK' },
        ],
      },
      /** 素材类别 */
      material_type_options: {
        loading: false,
        response: [
          { id: 1, label: '落地页' },
          { id: 2, label: '一击' },
        ],
      },
      /** 上报付费事件时效 */
      callback_pay_date_options: {
        response: [
          { id: 1, label: '注册首日内' },
          { id: 3, label: '注册3日内' },
          { id: 7, label: '注册7日内' },
          { id: 14, label: '注册14日内' },
          { id: 30, label: '注册30日内' },
        ],
      },
      /** 投放素材数据集合 */
      material_id_options: {},
      /** 表单model */
      ruleForm: {
        channels: {},
        add_extend_package: true,
        app_ids: [],
      },
      rules: {
        channels: [
          { required: true, message: '请填入渠道', trigger: ['change'] },
        ],
      },
      filter_obj: {
        game_ids: {
          label: '游戏',
          placeholder: '请选择游戏',
          props: {
            options: [],
            ischeckbox: false,
            'check-on-click-node': true,
            props: {
              value: 'id',
              label: 'name',
              children: 'children',
            },
            'select-props': {
              placeholder: '请选择游戏',
              clearable: true,
              accordion: true,
              size: 'small',
            },
          },
          on: {
            getValue: (game_id, value_name, jrtt_app_id, gdt_app_id) => {
              this.$refs['ruleForm'].validateField([`channels.${this.current_tab}.game_id`]);
              if (game_id) {
                this.ruleForm.channels[this.current_tab].config.app_id = isNullOrUnDef(gdt_app_id) ? '' : String(gdt_app_id);
                this.ruleForm.channels[this.current_tab].game_id = game_id;
                this.material_id_options[this.current_tab].response.splice(0);
                this.ruleForm.channels[this.current_tab].material_id = null;
                this.getAvdMaterial().then((result) => {
                  this.material_id_options[this.current_tab].response = result.list;
                  /** 默认值：直链(勿删) */
                  const target = result.list.find(item => item.id === this.map_material_type.landing_page);
                  const is_landing_page = this.ruleForm.channels[this.current_tab].material_type === this.map_material_type.landing_page;
                  /** 有值并且素材类别是落地页才赋值素材默认值 */
                  if (target && is_landing_page) {
                    this.ruleForm.channels[this.current_tab].material_id = this.map_material_type.landing_page;
                  }
                });
              }
            },
          },
          value: null,
        },
      },
      /** 分类 */
      advertiser: {
        loading: false,
        params: {
          module: 'ad',
          key: 'gdt_channel_type1',
        },
        response: [],
      },
      /** 子分类数据集 */
      type2_options: {},
      /** channels监听器解除的对象 */
      map_unwatch_handler: {},
      /** 广告主ID */
      table_advertiser: {
        loading: false,
        params: {
          module: 'ad',
          key: 'gdt_pack_account',
        },
        response: [],
        checked: 14459010,
      },
      /**
       * 出价方式
       * 参数是自定义的，媒体没有用到，用在我们自己的后台，给推广用来标记的。
       * 目前需要加的时候，前端随便自定义一个加上去就行
       */
      api_bid_mode_options: {
        response: store.getters.gdtEnum.api_bid_mode,
      },
      callback_field_keys: ['callback_first_pay', 'callback_min_pay', 'callback_max_pay', 'callback_pay_percent', 'pay_callback_rate', 'callback_type_active_rate', 'callback_type_register_rate', 'callback_pay_date', 'callback_type_pay_rate_n_day', 'callback_type_pay_rate_n_rate'],
    };
  },
  computed: {
    formChannelsInfo() {
      const channels = Object.values(this.ruleForm.channels);
      let is_save_length = 0;
      let is_no_save_length = 0;
      channels.forEach(channel => {
        if (channel.tab_is_save) {
          is_save_length += 1;
        } else {
          is_no_save_length += 1;
        }
      });
      return {
        total: channels.length,
        is_save_length,
        is_no_save_length,
      };
    },
  },
  mounted() {
    /** 获取游戏 */
    this.getGameList({ refresh: 1 }).then((res) => {
      for (let i = 0; i < res.list.length; i++) {
        res.list[i]['disabled'] = true;
      }
      this.filter_obj.game_ids.props.options = res.list;
    });
  },
  created() {
    this.initFormChannels();
    this.initOptionsData([this.material_id_options, this.type2_options]);
    this.initType1ConfigList();
    this.initAdConfigList();
    this.getChannelInterfaceAdvertiser();
  },
  methods: {
    /** 初始化广告主配置 */
    initAdConfigList() {
      this.table_advertiser.loading = true;
      this.getConfigList(this.table_advertiser.params).then((response) => {
        this.table_advertiser.response = response;
      }).finally(() => {
        this.table_advertiser.loading = false;
      });
    },

    /** 初始化分类配置列表 */
    initType1ConfigList() {
      this.advertiser.loading = true;
      this.getConfigList(this.advertiser.params).then((response) => {
        this.advertiser.response = response;
      }).finally(() => {
        this.advertiser.loading = false;
      });
    },

    /** 获取tag的状态类型 */
    getTagType(tag) {
      const mupTuple = [
        [() => tag.tab_is_save, () => 'success'],
        [() => !tag.tab_is_save && tag.tab_uuid === this.current_tab, () => 'primary'],
        [() => !tag.tab_is_save, () => 'info'],
      ];
      const target = mupTuple.find(([m]) => m());
      return target ? target[1]() : 'info';
    },

    /** 切换广告主 */
    changeAdvertiser(val){
      this.table_advertiser.checked = val;
      this.ruleForm.app_ids.splice(0);
      this.setTableParams();
    },

    /** 初始化表单channels数据 */
    initFormChannels() {
      const uuid = this.genUUID();
      this.current_tab = uuid;
      this.$set(this.ruleForm.channels, uuid, this.genFormChannelData(uuid));
    },

    /** 生成唯一uuid */
    genUUID() {
      return `${Date.now()}`;
    },

    /** 生成表单中channel数据 */
    genFormChannelData(tab_uuid = this.genUUID(), tab_title = '未保存') {
      const channel = {
        alias: '',
        name: '',
        plf_type: 1,
        game_id: null,
        type1: null,
        type2: null,
        material_type: 1,
        material_id: null,
        config: {
          app_id: '',
          ad_account: undefined,
          cost_type: 3,
          platform: 3,
          callback_type: [
            'active',
            'register',
            'pay',
            'key',
            'purchase_roi',
            'create_role',
          ],
          callback_method: 'sdk',
          advertiser: 'gdtnew',
          bid_mode: 'active_roi',
          callback_first_pay: 0,
          callback_min_pay: '',
          callback_max_pay: '',
          callback_pay_percent: '',
          pay_callback_rate: '',
          callback_type_active_rate: '',
          callback_type_register_rate: '',
          callback_pay_date: 30,
          callback_type_pay_rate_n_day: '',
          callback_type_pay_rate_n_rate: '',
          parent_callback_type: 0,
        },
        converts: [this.genConvertFormSchema()],
        tab_is_save: false,
        tab_title,
        tab_uuid,
        collapse_callback: true,
      };
      return channel;
    },

    /** 初始化下拉框数据的值 */
    initOptionsData(targets) {
      targets.forEach((target) => {
        const data = { loading: false, response: [] };
        this.$set(target, this.current_tab, data);
      });
    },

    /** 获取当前渠道的表单key */
    getCurrentChannelFormFields(entry = {}, parentKey = `channels.${this.current_tab}.`, result = {}, prefix = '.') {
      Object.keys(entry).forEach(key => {
        const keyName = `${parentKey}${key}`;
        if (isObject(entry[key]) || isArray(entry[key])) {
          this.getCurrentChannelFormFields(entry[key], `${keyName}${prefix}`, result);
        } else {
          result[keyName] = entry[key];
        }
      });
      return Object.keys(result);
    },

    /** 设置请求应用表格参数 */
    setTableParams() {
      const app_ids = [];
      const tabs = Object.values(this.ruleForm.channels);
      tabs.forEach(channel => {
        if (channel.tab_is_save) {
          app_ids.push(channel.config.app_id);
        }
      });
      this.table_params.params.advertiser_id = this.table_advertiser.checked;
      this.table_params.params.app_ids = app_ids;
      app_ids.length && this.getAppList();
    },

    /** 移除表单channel单个监听**/
    removeChannelWatch() {
      if (this.map_unwatch_handler[this.current_tab]) {
        this.map_unwatch_handler[this.current_tab]();
        this.$delete(this.map_unwatch_handler, this.current_tab);
      }
    },

    /** 移除表单channels所有监听**/
    removeChannelsWatch() {
      Object.entries(this.map_unwatch_handler).forEach(([key, value]) => {
        value();
        this.$delete(this.map_unwatch_handler, key);
      });
    },

    /**
     * 表单channel添加监听
     * @param {*} index 索引
     */
    addChannelWatch(index) {
      this.map_unwatch_handler[index] = this.$watch(`ruleForm.channels.${index}`, function() {
        this.ruleForm.channels[index].tab_is_save = false;
        this.ruleForm.channels[index].tab_title = '未保存';
      }, { deep: true });
    },

    /**
     * 保存当前渠道数据参数
     * @param {*} pane 当前面板绑定的channel对象
     */
    onChannelSave(pane) {
      const field_keys = this.getCurrentChannelFormFields(pane);
      const result = [];
      this.$refs.ruleForm.validateField(field_keys, (res) => {
        if (res) {
          result.push(res);
        }
      });
      if (!result.length) {
        this.removeChannelWatch();
        this.$set(pane, 'tab_title', `渠道名称${pane.name}<br/><hr/>渠道标识${pane.alias}`);
        this.$set(pane, 'tab_is_save', true);
        this.$message.success('保存成功，可点击左侧渠道列表查看渠道参数');
        this.addChannelWatch(this.current_tab);
        this.ruleForm.app_ids.splice(0);
        this.setTableParams();
      } else {
        this.$message.error(result[0]);
      }
    },

    /**
     * 重置当前渠道数据参数
     * @param {*} pane 当前面板绑定的channel对象
     */
    onChannelReset(pane) {
      const field_keys = this.getCurrentChannelFormFields(pane);
      field_keys.forEach((item) => {
        this.$refs[item] && this.$refs[item].resetField();
      });
      this.ruleForm.channels[this.current_tab].game_id = null;
      this.ruleForm.channels[this.current_tab].tab_is_save = false;
      this.ruleForm.channels[this.current_tab].tab_title = '未保存';
      this.$refs[`select-tree`].clearHandle();
      this.$set(this.filter_obj.game_ids, 'value', null);
      this.type2_options[this.current_tab].response.splice(0);
    },

    /** 处理应用分包多选 */
    handleSelectionChange(val) {
      this.multiple_selection = val;
      this.ruleForm.app_ids.splice(0);
      this.ruleForm.app_ids = this.multiple_selection.map((item) => {
        return {
          app_id: item.type_id,
          advertiser_id: item.advertiser_id,
        };
      });
    },

    /** 获取应用列表 */
    getAppList() {
      this.app.loading = true;
      return new Promise((resolve, reject) => {
        const { advertiser_id, promoted_object_type: delivery_platform_type, app_ids } = this.table_params.params;
        getDeliveryContentApi({
          channel_interface: CHANNEL_INTERFACE_TYPE.GDT,
          advertiser_id,
          filtering: {
            delivery_platform_type,
            app_ids,
          },
        })
          .then((response) => {
            response.list = response.list.map(({ id, name, delivery_platform_type }) => ({ advertiser_id, type_id: id, promoted_object_name: name, promoted_object_type: delivery_platform_type }));
            this.app.response = response;
            this.$refs['multipleTable'].toggleAllSelection();
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          })
          .finally(() => {
            this.app.loading = false;
          });
      });
    },

    /** 获取广告配置列表 */
    getConfigList: function(params) {
      return new Promise((resolve, reject) => {
        configResource
          .getConfigDataApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /** 获取渠道子分类 */
    getChannelList(parent) {
      this.type2_options[this.current_tab].response.splice(0);
      if (this.ruleForm.channels[this.current_tab]) {
        this.ruleForm.channels[this.current_tab].type2 = null;
      }
      advResource.getChannelTypeApi({ parent }).then((response) => {
        this.type2_options[this.current_tab].response = response.list;
      });
    },

    /** 获取投放系统素材列表 */
    getAvdMaterial() {
      return new Promise((resolve, reject) => {
        advResource
          .getAvdMaterialApi({
            simple: 1,
            game_id: this.ruleForm.channels[this.current_tab].game_id,
          })
          .then((res) => {
            resolve(res);
          })
          .catch(reject);
      });
    },

    /** 重新监听已保存的表单channel */
    reListenFormChannel() {
      Object.values(this.ruleForm.channels).forEach((cha) => {
        cha.tab_is_save && this.addChannelWatch(cha.tab_uuid);
      });
    },

    /** 清除当前渠道的表单验证 */
    clearValidateCurrentChannel(tag) {
      this.$nextTick(() => {
        const field_keys = this.getCurrentChannelFormFields(tag);
        this.$refs['ruleForm'].clearValidate(field_keys);
      });
    },

    /** 点击tag */
    onClickTab(tag) {
      if (this.current_tab === tag.tab_uuid) {
        return;
      }
      this.current_tab = tag.tab_uuid;
      this.$refs[`select-tree`].clearHandle();
      this.clearValidateCurrentChannel(tag);
      this.reassignGameValue();
    },

    /**
     * 监听移除tab面板
     * @param {string} target_name 当前tab的name
     */
    onRemoveTab(target_name) {
      this.removeChannelsWatch();
      const tab_uuids = Object.keys(this.ruleForm.channels);
      let active_name = this.current_tab;
      if (active_name === target_name) {
        tab_uuids.forEach((tab_uuid, index) => {
          if (tab_uuid === target_name) {
            const next_tab_uuid = tab_uuids[index + 1] || tab_uuids[index - 1];
            if (next_tab_uuid) {
              active_name = next_tab_uuid;
            }
          }
        });
      }
      this.current_tab = active_name;
      this.$delete(this.ruleForm.channels, target_name);
      this.$delete(this.material_id_options, target_name);
      this.$delete(this.type2_options, target_name);
      this.reListenFormChannel();
    },

    /** 添加渠道面板 */
    addTab() {
      this.removeChannelsWatch();
      const uuid = this.genUUID();
      const tag = this.genFormChannelData(uuid);
      this.$set(this.ruleForm.channels, uuid, tag);
      this.current_tab = uuid;
      this.$refs[`select-tree`].clearHandle();
      this.clearValidateCurrentChannel(tag);
      this.initOptionsData([this.material_id_options, this.type2_options]);
      this.reListenFormChannel();
      this.$nextTick(() => {
        const active_tag = this.$refs.tagScrollbarRef.querySelector('.tag-item.active');
        active_tag?.scrollIntoView({ behavior: 'smooth' });
      });
    },

    /** 获取游戏列表 */
    getGameList: function(params) {
      return new Promise((resolve, reject) => {
        advertisingResource
          .getGameListApi(params)
          .then((response) => {
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    /** 修改深度优化行为目标 */
    changeDeep(val, index) {
      val && this.$delete(this.ruleForm.channels[this.current_tab].converts[index], 'deep_worth_optimization_goal');
    },

    /** 修改深度优化 ROI 目标 */
    changeROI(val, index) {
      val && this.$delete(this.ruleForm.channels[this.current_tab].converts[index], 'deep_behavior_optimization_goal');
    },

    /**
     * 监听分类改变
     * @param {*} index 当前选中的值
     */
    onType1Change(index) {
      this.getChannelList(index);
    },

    // 批量增加转化
    addConversion() {
      const find = Object.values(this.ruleForm.channels).find((item) => !item.tab_is_save);
      if (find) {
        this.$message.warning('存在未保存的渠道，请先保存或删除该渠道再操作！');
        return;
      }
      this.$refs['ruleForm'].validate((valid, results) => {
        if (valid) {
          this.submit_loading = true;
          const postData = JSON.parse(JSON.stringify(this.ruleForm));
          postData.channels = Object.values(postData.channels).sort((a, b) => a.tab_uuid - b.tab_uuid);
          postData.channels.forEach((ch) => {
            delete ch.tab_is_save;
            delete ch.tab_title;
            delete ch.tab_uuid;
            delete ch.collapse_callback;
            /** 素材类别不是落地页时删除素材字段 */
            if (ch.material_type !== this.map_material_type.landing_page || isNull(ch.material_id)) {
              delete ch.material_id;
            }
            const regex = /^-?\d+(\.\d+)?$/;
            this.callback_field_keys.forEach(field_key => {
              if (regex.test(ch.config[field_key])) {
                ch.config[field_key] = +ch.config[field_key];
              } else {
                delete ch.config[field_key];
              }
            });
          });
          convertResource
            .bacthAddConvert(postData)
            .then((response) => {
              this.$alert(response.message, '执行结果', { confirmButtonText: '确定', customClass: 'create-track-alert-box' });
              this.$emit('config');
              this.removeChannelsWatch();
            })
            .finally(() => {
              this.loading = false;
              this.submit_loading = false;
            });
        } else {
          const result = Object.values(results)[0];
          this.$message.error(result[0]?.message);
          return false;
        }
      });
    },

    // 确定
    configAddDialog() {
      this.addConversion();
    },

    // 取消
    closeAddDialog() {
      this.$emit('cancel');
    },

    /** 监听素材类别选择 */
    onMaterialTypeChange(type) {
      /** 不是落地页则重置素材id */
      if (type !== this.map_material_type.landing_page) {
        this.ruleForm.channels[this.current_tab].material_id = null;
      }
    },

    /** 复制渠道 */
    onCopyChannel(uuid) {
      const is_exist_channel = Object.prototype.hasOwnProperty.call(this.ruleForm.channels, uuid);
      if (!is_exist_channel) {
        return;
      }
      /** 复制渠道 */
      const copy_channel = JSON.parse(JSON.stringify(this.ruleForm.channels[uuid]));
      /** 复制子分类 */
      const copy_type2_options = JSON.parse(JSON.stringify(this.type2_options[uuid]));
      /** 复制素材 */
      const copy_material_options = JSON.parse(JSON.stringify(this.material_id_options[uuid]));
      this.addTab();
      this.$set(this.ruleForm.channels, this.current_tab, {
        ...copy_channel,
        tab_uuid: this.current_tab,
        tab_is_save: false,
        tab_title: '未保存',
      });
      this.$set(this.type2_options, this.current_tab, copy_type2_options);
      this.$set(this.material_id_options, this.current_tab, copy_material_options);
      this.reassignGameValue();
    },

    /** 对游戏重新赋值，用于回显下拉框数据 */
    reassignGameValue() {
      const game_id = this.ruleForm.channels[this.current_tab].game_id;
      this.$refs['select-tree'].value_id = game_id;
      this.$refs['select-tree'].initHandle();
    },
    /**
     * 生成转化表单模型
     * @requires {Object}
     */
    genConvertFormSchema() {
      return {
        optimization_goal: '',
        deep_behavior_optimization_goal: '',
        deep_worth_optimization_goal: '',
      };
    },
    /**
     * 监听出价方式改变事件
     * @param {string} val 当前选中的值
     */
    onBidModeChange(val) {
      /** 是否是混变ROI */
      const is_mixed_variable_roi = val === 'mixed_variable_roi';
      /** 出价方式是混变ROI时支持多组合 */
      if (is_mixed_variable_roi) {
        this.ruleForm.channels[this.current_tab].converts.push(this.genConvertFormSchema());
        return;
      }
      if (this.ruleForm.channels[this.current_tab].converts.length > 1) {
        this.ruleForm.channels[this.current_tab].converts.pop();
      }
    },
    /**
     * 读取模板
     * @returns {void}
     */
    async onReadTemplate() {
      Object.assign(this.template_config, { is_show: true });
    },
    /**
     * 应用模板
     * @param {Object} template 模板数据
     * @returns {void}
     */
    async applicationTemplate(template,) {
      Object.assign(this.template_config, { is_show: false, template_data: template.template_data });
      const template_data = JSON.parse(template.template_data);

      /** 手动执行分类change事件获取新的子分类列表 */
      this.onType1Change(template_data.type1);

      /** 对当前活动的tab表单进行赋值 */
      Object.assign(this.ruleForm.channels[this.current_tab], {
        ...template_data,
        tab_is_save: false,
      });

      /** 获取素材列表 */
      this.material_id_options[this.current_tab].response.splice(0);
      this.getAvdMaterial().then((result) => {
        this.material_id_options[this.current_tab].response = result.list;
      });
    },
    /**
     * 保存模板
     * @returns {void}
     */
    async onSaveTemplate() {
      const field_keys = this.getCurrentChannelFormFields(this.ruleForm.channels[this.current_tab]);
      const result = [];
      this.$refs.ruleForm.validateField(field_keys, (res) => {
        if (res) {
          result.push(res);
        }
      });
      if (result.length) {
        this.$message.error(result[0]);
        return;
      }
      const channel_data = clone(this.ruleForm.channels[this.current_tab]);
      const name = channel_data.name;
      delete channel_data.name;
      delete channel_data.alias;
      delete channel_data.tab_is_save;
      delete channel_data.tab_uuid;
      const payload = {
        advertiser: 'gdt',
        type: 'gdt_tracking',
        name: `${name}|${randomUUID()}`,
        template_data: JSON.stringify(channel_data),
      };
      const ret = await templateResource.addTemplateData(payload);
      this.$message.success(ret?.message || '保存成功');
    },
    /** 获取广告商 */
    getChannelInterfaceAdvertiser() {
      return new Promise((resolve, reject) => {
        getChannelInterfaceAdvertiserApi({ channel_interface: CHANNEL_INTERFACE_TYPE.GDT }).then((res) => {
          const result = (res.list || []).map(({ id, name }) => ({ label: name, value: id }));
          this.advertiser_options.response = result;
          resolve(res);
        }).catch(reject);
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.dialog-footer {
  width: 100%;
  text-align: center;
  display: block;
}

.custom-cursor-pointer {
  cursor: pointer;
}

.visible {
  visibility: visible;
}

.invisible {
  visibility: hidden;
}

.actions-wrap {
  padding: 30px 0;
  position: sticky;
  bottom: 0;
  background: white;
  border-top: 1px solid #eee;
  z-index: 9;
}

.batch-track-wrapper {
  .tag-scrollbar-wrapper {
    height: calc(100vh - 260px);
    border-right: 1px solid #eee;
    overflow-x: hidden;
    overflow-y: auto;
  }
  /deep/ .el-badge__content.is-fixed.is-dot {
    top: 4px;
  }
  .sidebar-wrapper {
    position: fixed;
    width: 120px;
  }
  .content-wrapper {
    margin-left: 140px;
    .template-action {
      text-align:right;
      position: sticky;
      top: 0;
      height: fit-content;
      z-index: 2001;width: 100%;background-color: #fff;
    }
  }
}

</style>

<style lang="scss">
.el-message-box{
  &.create-track-alert-box {
    width: 420px!important;
  }
}
</style>
